import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
import { DprHseReport } from '@report/models';
import { StaticMessage } from '@shared/enums';
import { DprHse } from '@shared/models/dpr';
import {
  Hse,
  SubprojectConfigurationCustomNames,
} from '@shared/models/project-setup';

@Component({
  selector: 'app-report-hse',
  templateUrl: './report-hse.component.html',
  styleUrls: ['./report-hse.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportHseComponent implements OnInit {
  @Input({ required: true }) hseList: Hse[];
  @Input({ required: true }) dprHse: DprHse;
  @Input({ required: true }) customNames: SubprojectConfigurationCustomNames;

  hseReport: DprHseReport[] = [];

  StaticMessage = StaticMessage;

  ngOnInit(): void {
    this.hseList.forEach((hse) => {
      const detail = (this.dprHse.dprhseDetails || []).find(
        (x) => x.hseId === hse.id
      );

      this.hseReport.push({
        name: hse.name,
        previous: detail.previous,
        today: detail.today ?? '-',
        total: detail.previous + (detail.today ?? 0),
        comment: detail.comment ?? '-',
      });
    });
  }
}
